import { createContext, useState } from "react"
import { getGraphQLErrorMessage } from "@helpers"

const NotificationContext = createContext()

const NotificationContextProvider = ({ children }) => {
  const [notification, setNotification] = useState({
    icon: null,
    title: null,
    type: "info",
    content: null,
    open: false,
    timeout: 10000,
    onCloseCallBack: () => {},
  })

  const notify = (details) => {
    setNotification({ ...notification, ...details })
  }

  const notifyError = (error, fallbackMessage = "An error occurred") => {
    setNotification({ ...notification, title: "Error", type: "danger", content: getGraphQLErrorMessage(error, fallbackMessage), open: true })
  }

  const setOpen = open => setNotification(prevState => ({ ...prevState, open }))

  return (
    <NotificationContext.Provider value={{ notification, setNotification, open: notification.open, setOpen, notify, notifyError, onCloseCallBack: notification.onCloseCallBack }}>
      {children}
    </NotificationContext.Provider>
  )
}

export { NotificationContext, NotificationContextProvider }
